__turbopack_context__.v({
  "accordion_content": "Accordion-module-scss-module__HnbkXq__accordion_content",
  "accordion_item": "Accordion-module-scss-module__HnbkXq__accordion_item",
  "accordion_title": "Accordion-module-scss-module__HnbkXq__accordion_title",
});
